import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { ButtonGroup, Dialog, Icon, Icons, TextButton, TextInput, Typography } from '../../components';
import { ComponentSize, TextColor } from '../../types';

interface ScorecardTemplateInUseModalProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  initialScorecardName: string;
  onConfirm: (newName: string) => void;
}

const ScorecardTemplateInUseModal = ({
  isOpen,
  setIsOpen,
  initialScorecardName,
  onConfirm,
}: ScorecardTemplateInUseModalProps) => {
  const [newScorecardName, setNewScorecardName] = useState('');

  // Set the initial scorecard name
  useEffect(() => {
    setNewScorecardName(initialScorecardName);
  }, [initialScorecardName]);

  const handleConfirm = () => {
    onConfirm(newScorecardName);
    setIsOpen(false);
  };

  const handleClose = () => {
    setNewScorecardName(initialScorecardName);
    setIsOpen(false);
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      title="Scorecard in use"
      icon={<Icons icon={Icon.INFO} color={TextColor.INVERSE} size={ComponentSize.LARGE} />}
      description="This scorecard is in use. To save your changes as a new scorecard, provide a name below."
    >
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <Typography>Scorecard name</Typography>
          <TextInput value={newScorecardName} onChange={(e) => setNewScorecardName(e.target.value)} />
        </div>
        <ButtonGroup>
          <TextButton text="Create" onClick={handleConfirm} />
          <TextButton text="Cancel" onClick={handleClose} />
        </ButtonGroup>
      </div>
    </Dialog>
  );
};

export default ScorecardTemplateInUseModal;
